import { render } from "./Papa-Krabbelgruppe.vue?vue&type=template&id=9ab241e8"
import script from "./Papa-Krabbelgruppe.vue?vue&type=script&lang=js"
export * from "./Papa-Krabbelgruppe.vue?vue&type=script&lang=js"

import "./Papa-Krabbelgruppe.vue?vue&type=style&index=0&id=9ab241e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__